/*
 * @Author: codesides
 * @Descripttion:
 * @Date: 2022-05-06 17:56:52
 * @LastEditors: codesides
 * @LastEditTime: 2025-12-04 16:30:03
 * @FilePath: \lesson-web-cms\src\store\index.ts
 */
import { createStore } from "vuex";
import { getUserInfo, getDomains, getPermission, getCommon } from "@/api/common";
// import { getMoreUserLogin } from '@/api/selectUsr'
import { authLoginMiddleware } from "@/store/authLogin";
import createPersistedstate from "vuex-persistedstate";
import router from "@/router";
import { navigateto } from "@/utils/tools";
import Cookies from "js-cookie";
export interface BaseDomain {
  fileDomain?: string;
  lessonApiDomain?: string;
  lessonDomain?: string;
  mobileDomain?: string;
  mykehouApiDomain?: string;
  orderDomain?: string;
  portalDomain?: string;
  privateFileDomain?: string;
  storageDomain?: string;
  tmsDomain?: string;
  toLoginUrl?: string;
  uploadFileDomain?: string;
}

const { getMoreUserLogin } = authLoginMiddleware();

export default createStore({
  state: {
    toLogin: false,
    isLogin: false,
    loaded: false,
    userInfo: {
      isjx: false,
    },
    domains: {} as BaseDomain,
    permission: {
      modules: [],
      permissions: [],
    },
    moreUserList: [],
    showNotice: false,
  },
  getters: {
    getModules(state) {
      return state.permission.modules || [];
    },
    getPermissions(state) {
      return state.permission.permissions || [];
    },
  },
  mutations: {
    SET_TOLOGIN(state, paylaod) {
      state.toLogin = paylaod;
    },
    SET_ISLOGIN(state, paylaod) {
      state.isLogin = paylaod;
    },
    setIsjx(state, paylaod) {
      state.userInfo.isjx = paylaod;
    },
    SET_USERINFO(state, payload) {
      state.userInfo = payload;
    },
    SET_URL(state, payload) {
      state.domains = payload;
    },
    SET_LOADED(state, payload) {
      state.loaded = payload;
    },
    SET_PERMISSION(state, payload) {
      state.permission = payload;
    },
    setMoreUserList(state, payload) {
      state.moreUserList = payload;
    },
    SET_SHOWNOTICE(state, paylaod) {
      state.showNotice = paylaod;
    },
  },
  actions: {
    async GET_BASE({ commit, state }) {
      commit("SET_LOADED", false);
      commit("SET_PERMISSION", {
        modules: [],
        permissions: [],
      });

      let rtUrl = window.location.href.split("#")[1];
      getCommon().then((res) => {
        Cookies.set('X-Access-Token', res.data.loginToken || '')
        Promise.all([getUserInfo(), getDomains(), getPermission()])
        .then((res) => {
          commit("SET_USERINFO", res[0].data);
          if (
            (res[0].data.unitType === 0 &&
              window.location.pathname !== "/view/pc/") ||
            (res[0].data.unitType === 1 &&
              window.location.pathname !== "/view/area/")
          ) {
            window.location.href = `${state.domains.lessonDomain}/view/pc/#/login/login`;
          }
          commit("SET_URL", res[1].data);
          commit("SET_PERMISSION", res[2].data);

          const modules = res[2].data.modules || [];
          if (["/", "/home"].includes(rtUrl)) {
            if (modules.length) {
              const firstUrl = modules[0].url.replace("/view/area/#", "");
              if (firstUrl !== "/home") {
                if (firstUrl && !modules[0].openType) {
                  rtUrl = firstUrl;
                } else if (modules[0]?.children?.length) {
                  rtUrl = modules[0]?.children[0].url.replace(
                    "/view/area/#",
                    ""
                  );
                } else if (modules[0].openType) {
                  if (modules.length === 1) {
                    navigateto(firstUrl, "_self");
                    return;
                  } else {
                    const secondUrl = modules[1].url.replace(
                      "/view/area/#",
                      ""
                    );
                    const secondCUrl = modules[1].children
                      ? modules[1].children[0].url.replace("/view/area/#", "")
                      : "";
                    const finalUrl = secondUrl || secondCUrl;
                    rtUrl = finalUrl;
                  }
                }
              }
            } else {
              rtUrl = "/noPermission";
            }
          }
          commit("SET_LOADED", true);
          router.replace(rtUrl);
        })
        .catch((err) => {
          console.log(err);
          const { code } = err;
          switch (code) {
            case 4000:
            case 9000:
              commit("SET_LOADED", true);
              console.log(2);
              router.replace({
                path: "/noPermission",
                query: {
                  code: 9000,
                },
              });
              break;
          }
        });
      })

      getMoreUserLogin()
        .then((res) => {
          commit("setMoreUserList", res.data);
        })
        .catch((e) => console.log(e));
    },
    async GET_PERMISSION({ commit }) {
      const res = await getPermission();
      commit("SET_PERMISSION", res.data);
    },
    FetchMoreUserList({ commit }, payload) {
      commit("setMoreUserList", payload);
    },
  },
  plugins: [createPersistedstate({ key: "area" })],
});
